import React from 'react';
import {PublicApiReceiverResponse} from "../Representation";

interface ConsignmentWaypointAddressProps {
    waypoint?: PublicApiReceiverResponse | null;
}

const ConsignmentWaypointAddress = (
    props: ConsignmentWaypointAddressProps
) => {

    const addressAsArray = (waypoint?: PublicApiReceiverResponse | null) => {
        const result: string[] = [];
        if (!waypoint) {
            return result;
        }
        if (waypoint.companyName) result.push(waypoint.companyName);
        if (waypoint.address) {
            const address = waypoint.address;
            result.push(emptyIfNull(address.unitOrFlat) + emptyIfNull(address.street));
            result.push(emptyIfNull(address.suburb) + emptyIfNull(address.state) + emptyIfNull(address.postcode));
        }
        if (waypoint.contactNumber) {
            result.push("Contact Number: " + waypoint.contactNumber);
        }
        return result;
    };

    const emptyIfNull = (s?: string | null) => {
        return s ? s + " " : '';
    }


    const formattedAddress = addressAsArray(props.waypoint).map((line, index) => {
        return (
            <span key={index}>{line}<br /></span>
        )
    });

    return (
        <div>
            <p className="no-margin">{formattedAddress}</p>
        </div>
    )

}

export default ConsignmentWaypointAddress;
